module.exports = __webpack_public_path__ + "img/e497c52.png";